import { State } from '../../../weborder/Store';

export const selectMenuByUrl = (
  state: State['menu']['menus'],
  props: { menuUrl: string },
) => {
  const menu = state[props.menuUrl];
  if (menu && menu.status === 'success') {
    return menu.data;
  }

  return null;
};
